import React from 'react';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';

/**
 * The single bridge from a legacy container block's stored children to Volto's
 * own block renderer.
 *
 * Every container in this package stores its children in exactly the shape
 * `RenderBlocks` already expects -- a `blocks` mapping plus a `blocks_layout`
 * order -- so there is nothing to translate. That is also why a `columnsBlock`
 * nested inside a tab renders with no extra wiring: the nested block is looked
 * up in `blocksConfig` like any other, and finds the view registered here.
 *
 * `holder` is whichever object owns the children. For an accordion panel, a
 * tab, or a column that is the object itself; for a top-level container block
 * it is the block's own `data` key. Callers pass the right one.
 */
const Inner = ({ holder, ...rest }) => {
  const items = holder?.blocks_layout?.items;
  if (!items || items.length === 0) return null;
  return (
    <RenderBlocks
      {...rest}
      content={{ blocks: holder.blocks || {}, blocks_layout: holder.blocks_layout }}
      isContainer
    />
  );
};

export default Inner;
